import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "data"];
import { useEffect, memo, useRef } from 'react';
let hoveredRowId;
function addHoverClass(el) {
  const rows = document.querySelectorAll('.ag-row--action-hover');
  for (let row of rows) {
    var _row$classList;
    (_row$classList = row.classList) === null || _row$classList === void 0 ? void 0 : _row$classList.remove('ag-row--action-hover');
  }
  const rowsHovered = el.querySelectorAll(`[row-id='${hoveredRowId}']`);
  for (let row of rowsHovered) {
    setTimeout(() => {
      var _row$classList2;
      (_row$classList2 = row.classList) === null || _row$classList2 === void 0 ? void 0 : _row$classList2.add('ag-row--action-hover');
    });
  }
}
function BaseReactCell(_ref) {
  let {
      children,
      data
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const firstTime = useRef(true);
  useEffect(() => {
    var _props$context, _props$context2;
    if (!(props !== null && props !== void 0 && (_props$context = props.context) !== null && _props$context !== void 0 && _props$context.hasActions) || !firstTime.current) return;
    firstTime.current = false;
    const node = props.node;
    const tableId = (props === null || props === void 0 ? void 0 : (_props$context2 = props.context) === null || _props$context2 === void 0 ? void 0 : _props$context2.tableId) || '';
    const elementId = tableId ? `w5-actions-component-${tableId}` : 'w5-actions-component';
    function getBodyViewPort() {
      var _props$context3, _props$context3$table, _props$context3$table2;
      const tableDiv = (props === null || props === void 0 ? void 0 : (_props$context3 = props.context) === null || _props$context3 === void 0 ? void 0 : (_props$context3$table = _props$context3.tableRef) === null || _props$context3$table === void 0 ? void 0 : (_props$context3$table2 = _props$context3$table.current) === null || _props$context3$table2 === void 0 ? void 0 : _props$context3$table2.eGridDiv) || null;
      let bodyViewport = props.api.gridBodyCtrl.eBodyViewport;
      if (tableDiv) {
        bodyViewport = tableDiv.querySelector('.ag-body-viewport');
      }
      return bodyViewport;
    }
    const actionsWrapper = document.getElementById(elementId);
    props.eGridCell.addEventListener('mouseover', () => {
      var _props$eGridCell;
      const bodyViewport = getBodyViewPort();
      const bodyViewportContent = bodyViewport.children;
      let bodyViewportContentChild;
      for (let current of bodyViewportContent) {
        if (current.classList.contains('ag-center-cols-clipper')) {
          bodyViewportContentChild = current;
        }
      }

      // We need to inform about that to add the correct style to prevent overlap the scroll bar.
      const hasScroll = bodyViewportContentChild.offsetHeight > bodyViewport.offsetHeight;
      props.context.getHoveredRowInfo({
        data: data,
        hasScroll,
        rowElement: props === null || props === void 0 ? void 0 : (_props$eGridCell = props.eGridCell) === null || _props$eGridCell === void 0 ? void 0 : _props$eGridCell.offsetParent
      });
      hoveredRowId = node.id;
      const scrollTop = bodyViewport.scrollTop;
      const centerElement = 40 - scrollTop;
      const actionsTop = node.rowTop + centerElement;
      if (actionsWrapper) {
        actionsWrapper.style.display = 'block';
        actionsWrapper.style.top = `${actionsTop + 3}px`;
        actionsWrapper.style.height = `${node.rowHeight - 2}px`;
        bodyViewport.onscroll = () => {
          actionsWrapper.style.display = 'none';
        };
      }
    });

    // need all this eventListeners because some overlap the others
    // >> when I'm out from one, can be over the other, and if we don't add
    // >> this three eventListeners may cause undesired flickering in some cases
    props.eGridCell.addEventListener('mouseout', () => {
      if (actionsWrapper) {
        actionsWrapper.style.display = 'none';
      }
    });
    actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.addEventListener('mouseover', () => {
      if (actionsWrapper) {
        addHoverClass(getBodyViewPort());
        actionsWrapper.style.display = 'block';
      }
      props.context.possibleScrolledRow = node.id;
    });
    actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.addEventListener('mouseout', () => {
      var _props$context4;
      if (actionsWrapper) {
        actionsWrapper.style.display = 'none';
      }
      if ((props === null || props === void 0 ? void 0 : (_props$context4 = props.context) === null || _props$context4 === void 0 ? void 0 : _props$context4.possibleScrolledRow) === node.id) {
        actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.scrollTo(0, 0);
        props.context.possibleScrolledRow = '';
      }
    });
    if (actionsWrapper) {
      const wheelEvent = 'onWheel' in actionsWrapper ? 'wheel' : 'mousewheel';
      actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.addEventListener(wheelEvent, function (event) {
        var _props$context5;
        if ((props === null || props === void 0 ? void 0 : (_props$context5 = props.context) === null || _props$context5 === void 0 ? void 0 : _props$context5.possibleScrolledRow) === node.id) {
          const bodyViewport = getBodyViewPort();
          bodyViewport.scrollBy(event.deltaX, event.deltaY);
          if (actionsWrapper) {
            actionsWrapper.style.display = 'none';
          }
        }
      });
    }
  }, [data, props]);
  return children;
}
export default /*#__PURE__*/memo(BaseReactCell);